import ApplicationController from './application_controller'

export default class ExpandableRowController extends ApplicationController {
  static targets = ['icon']
  static values = { rowId: String }

  toggle () {
    document.getElementById(this.rowIdValue).classList.toggle('is-hidden')
    this.iconTarget.classList.toggle('fa-angle-right')
    this.iconTarget.classList.toggle('fa-angle-down')
  }
}
